export enum MenuAction {
    EDIT = 'EDIT',
    EDIT_PROFIT_MANUALLY = 'EDIT_PROFIT_MANUALLY',
    ADD_ACCOUNT = 'ADD_ACCOUNT',
    DUPLICATE_ACCOUNT = 'DUPLICATE_ACCOUNT',
    ADD_SUBTOTAL = 'ADD_SUBTOTAL',
    ADD_GROUP = 'ADD_GROUP',
    SWITCH_ACCOUNT = 'SWITCH_ACCOUNT',
    INSERT_HEADER_ABOVE = 'INSERT_HEADER_ABOVE',
    INSERT_HEADER_BELOW = 'INSERT_HEADER_BELOW',
    INSERT_SPACING_ABOVE = 'INSERT_SPACING_ABOVE',
    INSERT_SPACING_BELOW = 'INSERT_SPACING_BELOW',
    DISABLE_FLI_NUMBERING = 'DISABLE_FLI_NUMBERING',
    ENABLE_FLI_NUMBERING = 'ENABLE_FLI_NUMBERING',
}
